export default "__VITE_ASSET__D5o_f_NN__"